import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useParams, useSearchParams, useNavigate} from "react-router-dom";
import {get} from 'lodash';

import analytic from 'utils/Analytic';

export default function ({printable}) {
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const dashboard = useSelector(state => state.insights_dashboard);
    const dashboard_filters = useSelector(state => state.dashboard_filters);
    const [searchParams] = useSearchParams();

    const school_id = get(dashboard_filters, 'filter-1.school_id', []);
    const student_id = get(dashboard_filters, 'filter-1.student_id', []);

    if (school_id.length > 1 || student_id.length != 1) {
        return null;
    }

    const onClick = () => {
        analytic.log('insightsClickPrint', {
            dashboard_id: dashboard.id,
            dashboard_title: dashboard.title,
            project_id: dashboard.project.id,
            project_name: dashboard.project.name,
            dashboard_filters: dashboard_filters
        });

        const query_string = searchParams.toString();
        const url = `/insights/${params.dashboard_id}/printable` + (query_string ? `?${query_string}` : '');
        navigate(url);
    }

    if (printable) {
        return null;
    }

    return (
        <button
            className="btn btn-on-white"
            onClick={onClick}
        >
            {`Print/PDF`}
        </button>
    );
}
